import { Container } from "./styles"

interface APIExecuterFormProps {
	children: React.ReactNode
}

export const APIExecuterForm = ({ children }: APIExecuterFormProps) => {
	return <Container>{children}</Container>
}
